import React from "react";
import { useParams } from "react-router-dom";
import { useUser } from "../../hooks/useUser";
import { useSearchInstallment } from "../../hooks/fetch-data/useSearchInstallment";
import { getLoanList, formatBackAccount } from "../../utils/loan";
import styles from "./style.module.css";
import HeaderComponent from "../Header/HeaderComponent";
import { formatMoneyNumber } from "../../utils/util";
import LoanStatus from "../../components/loan/LoanStatus/LoanStatus";
import LoadingPage from "../../components/LoadingPage/LoadingPage";
import { useTranslation } from "react-i18next";

const MyLoanStatusPage = () => {
  const { t } = useTranslation('loanStatus');
  const { loanId } = useParams();

  const { userData } = useUser();

  const { data: userLoanInfo, isFetching: isFetchingUserLoanInfo } =
    useSearchInstallment(userData?.id);

  const loans = getLoanList(userLoanInfo);

  const loanInfo = loans?.find((l) => l.loan_id === parseInt(loanId));

  const {
    loan_name,
    loan_amount,
    bank_accounts: { bank_account },
  } = loanInfo;

  if (isFetchingUserLoanInfo)
    return <LoadingPage message={t('loading')} />;

  return (
    <div className={styles.container}>
      <HeaderComponent onBack={() => {}} title={`${t('pageTitle')} ${loan_name}`} />
      <ul className={styles.list}>
        <li className={styles.row}>
          <span>{t('status')}</span>
          <LoanStatus status={loanInfo?.loan_state} />
        </li>
        <li className={styles.row}>
          <span>{t('loanNumber')}</span>
          <span className={styles.nextRound}>{loan_name}</span>
        </li>
        <li className={styles.row}>
          <span>{t('loanAmount')}</span>
          <span className={styles.nextRound}>
            {formatMoneyNumber(loan_amount)}
          </span>
        </li>
        <li className={styles.row}>
          <span>{t('installment')}</span>
          <span className={styles.nextRound}>12/12</span>
        </li>
        <li className={styles.row}>
          <span>{t('accountNumber')}</span>
          <span className={styles.nextRound}>
            {formatBackAccount(bank_account)}
          </span>
        </li>
        <li className={styles.row}>
          <span>{t('bank')}</span>
          <span className={styles.nextRound}>{t('kasikorn')}</span>
        </li>
      </ul>
    </div>
  );
};

export default MyLoanStatusPage;
